import PropTypes from 'prop-types';
import React from 'react';

import { Flex, Box } from 'reflexbox';

import {
  Button,
  Heading,
  Panel,
  PanelHeader,
  Space,
  Text,
} from 'rebass';

import { DarkerBox, ToggleView } from 'frontend/components';

import { PrivacyPolicy } from 'frontend/components/Pages/PrivacyPolicy';

const SimExpiration = ({ onDismiss }) => (
  <Panel theme="warning" style={{ maxWidth: 450, zIndex: 100 }}>
    <PanelHeader>
      <Heading level={4}>
        Expiration of Old Sims
      </Heading>
      <Space auto />
    </PanelHeader>
    <Box>
      <Heading level={5}>
        Heads up!
      </Heading>

      <Text my={2}>
        To ensure compliance with Blizzard&apos;s updated Data Protection policies, all sims will expire after 28 days
        as of January 2nd, 2020.
      </Text>
      <Text my={2}>
        The Raidbots Privacy Policy has been updated to reflect these changes.
      </Text>
      <Box my={2}>
        <ToggleView
          label="Privacy Policy"
          defaultOpen={false}
        >
          <DarkerBox style={{ maxHeight: 400, overflowY: 'scroll' }}>
            <PrivacyPolicy />
          </DarkerBox>
        </ToggleView>
      </Box>
      <Text my={2}>
        <a
          href="https://medium.com/raidbots/expiration-of-old-sims-1535326689a7"
          target="_blank"
          rel="noreferrer noopener"
        >
          Full details on the changes and instructions on how to download an archive of machine-readable raw data for
          your account
        </a>
      </Text>

      <Flex justify="center" mt={4}>
        <Button theme="success" onClick={onDismiss}>
          I Understand
        </Button>
      </Flex>
    </Box>
  </Panel>
);

SimExpiration.propTypes = {
  onDismiss: PropTypes.func.isRequired,
};

export default SimExpiration;
